<template>
  <!-- 银行担保 -->
<div class="OurService" style="align-self: center;">
    <!-- 黑头 -->
     <div class="header flex-all-center">
       <p>{{ $t("ourServiceBank.title")}}</p>
     </div>

     <div class="main">
      <div class="maincontent">
        <!-- 大宗贸易担保 -->
         <div class="mt-80 title-1">
          <p>{{ $t("ourServiceBank.text1")}}</p> 
         </div>
        
        <div class="textlayout mt-80">
          <div class="text">
            <p class="title-2">{{ $t("ourServiceBank.text2")}}</p>

            <p class="textcontent-en" v-if="isEn">{{ $t("ourServiceBank.text3")}}&nbsp;{{ $t("ourServiceBank.text4")}}&nbsp;{{ $t("ourServiceBank.text5")}}&nbsp;{{ $t("ourServiceBank.text6")}}&nbsp;{{ $t("ourServiceBank.text7")}}</p>
            <p class="textcontent-cn" v-else>{{ $t("ourServiceBank.text3")}}&nbsp;{{ $t("ourServiceBank.text4")}}&nbsp;{{ $t("ourServiceBank.text5")}}&nbsp;{{ $t("ourServiceBank.text6")}}&nbsp;{{ $t("ourServiceBank.text7")}}</p>
            
            <!-- 分割线 -->
             <div class="flex-all-center">
                <div class="separator"></div>
             </div>

            <p class="flex-all-center title-2">{{ $t("ourServiceBank.text8")}}</p>
            
            <p class="textcontent-en" v-if="isEn">{{ $t("ourServiceBank.text9")}}&nbsp;{{ $t("ourServiceBank.text10")}}&nbsp;{{ $t("ourServiceBank.text11")}}{{ $t("ourServiceBank.text12")}}&nbsp;{{ $t("ourServiceBank.text13")}}</p>
            <p class="textcontent-cn" v-else>{{ $t("ourServiceBank.text9")}}&nbsp;{{ $t("ourServiceBank.text10")}}&nbsp;{{ $t("ourServiceBank.text11")}}{{ $t("ourServiceBank.text12")}}&nbsp;{{ $t("ourServiceBank.text13")}}</p>
          </div>
        <img class="img1" src="../../assets/images/OurServiceBank_pic1.png">
        </div>
        
        <!-- 项目授信担保 -->
        <div class="mt-80 flex-all-center title-1">
          <p>{{ $t("ourServiceBank.text14")}}</p>
        </div>
        
        <div class="textlayout mt-80">
          <img class="img2" src="../../assets/images/OurServiceBank_pic2.png">

          <div class="text">
            <p class=" title-2">{{ $t("ourServiceBank.text15")}}</p>
            
            <p class="textcontent-en" v-if="isEn">{{ $t("ourServiceBank.text16")}}</p>
            <p class="textcontent-cn" v-else>{{ $t("ourServiceBank.text16")}}</p>

            <div class="flex-all-center">
                <div class="separator"></div>
             </div>
            <p class=" title-2">{{ $t("ourServiceBank.text17")}}</p>

            <p class="textcontent-en" v-if="isEn">{{ $t("ourServiceBank.text18")}}</p>
            <p class="textcontent-cn" v-else>{{ $t("ourServiceBank.text18")}}</p>

            <div class="flex-all-center">
                <div class="separator"></div>
             </div>
            <p class=" title-2">{{ $t("ourServiceBank.text19")}}</p>  

            <p class="textcontent-en" v-if="isEn">{{ $t("ourServiceBank.text20")}}</p>
            <p class="textcontent-cn" v-else>{{ $t("ourServiceBank.text20")}}</p>

            <div class="flex-all-center">
                <div class="separator"></div>
             </div>
            <p class=" title-2">{{ $t("ourServiceBank.text21")}}</p>

            <p class="textcontent-en" v-if="isEn">{{ $t("ourServiceBank.text22")}}</p>
            <p class="textcontent-cn" v-else>{{ $t("ourServiceBank.text22")}}</p>

          </div>
        </div>


        <!-- 其他担保业务 -->
        <div class="flex-all-center mt-80 title-1 ">
        <p>{{ $t("ourServiceBank.text23")}}</p>
        </div>

        <div class="textlayout mt-80">
          <div class="text">
              <p class="flex-all-center title-2">{{ $t("ourServiceBank.text24")}}</p>

              <p class="textcontent-en" v-if="isEn">{{ $t("ourServiceBank.text25")}}</p>
              <p class="textcontent-cn" v-else>{{ $t("ourServiceBank.text25")}}</p>

            <!-- 分割线 -->
              <div class="flex-all-center">
                <div class="separator"></div>
             </div>
              
              <p class="flex-all-center title-2">{{ $t("ourServiceBank.text26")}}</p>

              <p class="textcontent-en" v-if="isEn">{{ $t("ourServiceBank.text27")}}</p>
              <p class="textcontent-cn" v-else>{{ $t("ourServiceBank.text27")}}</p>

            <!-- 分割线 -->
              <div class="flex-all-center">
                <div class="separator"></div>
             </div>

              <p class="flex-all-center title-2">{{ $t("ourServiceBank.text28")}}</p>

              <p class="textcontent-en" v-if="isEn">{{ $t("ourServiceBank.text29")}}</p>
              <p class="textcontent-cn" v-else>{{ $t("ourServiceBank.text29")}}</p>

          </div>
          <img class="img3" src="../../assets/images/OurServiceBank_pic3.png">
        </div>

      </div>
     </div>
    <div class="footer"></div>
</div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "OurServiceBank",
  computed: {
    ...mapState({
      isEn: (state) => state.isEn,
    }),
  },
  data() {
    return {

    };
  },
  created() {

  },
  methods: {},

};
</script>

<style lang="scss" scoped>
.OurService{
  color: #000;
  width: 100%;
  .header{
    height: 400px;
    background: #000;
    font-family: "OPPO-L";
    font-size: 42px;
    color: #fff;
    p{
    text-align: center;
    }
  }
  .main{
    display: flex;
    justify-content: center;

    .maincontent{
    max-width: 1200px;
    color: #606266;
    font-family: "OPPO-R";
    font-size: 17px;
    line-height: 27px;
    margin-top: 17px;
    width: 100%;

    .title-1{
      text-align: center;
      color: #000;
      font-family: "OPPO-B";
      font-size: 40px;
    }

    .title-2 {
      text-align: center;
      font-family: "OPPO-B";
      font-size: 22px;
      color: #000;
    }

    .textlayout{
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .separator {
      height: 1.5px;
      background-color: #000;
      margin: 20px 97px;
      width: 350px;
    }

    p{
      margin-top: 17px;
    }

    .text{
      width: 544px;
    }

    .textcontent-cn{
      text-indent: 34px;
      text-align:justify;
    }

    .textcontent-en{
      text-indent: 34px;
      text-align: justify;
    }

    .img1{
      width: 600px;
      height: auto;
      margin-left: 100px;
    }
    .img2 {
      width: 600px;
      height: auto;
      margin-right: 100px;
    }
    .img3{
      width: 600px;
      height: auto;
      margin-left: 100px;
    }
    }
  }
  .footer
  {
    margin-top: 120px;
  }
}



@media (max-width: 768px) {

.OurService{
  color: #000;
  width: 100%;
  .header{
    height: 400px;
    background: #000;
    font-family: "OPPO-L";
    font-size: 42px;
    color: #fff;
    p{
    text-align: center;
    }
  }
  .main{
    display: flex;
    justify-content: center;

    .maincontent{
    max-width: 1200px;
    color: #606266;
    font-family: "OPPO-R";
    font-size: 17px;
    line-height: 27px;
    margin-top: 0px;
    width: 90%;

    .title-1{
      text-align: center;
      color: #000;
      font-family: "OPPO-B";
      font-size: 40px;
      line-height: 40px;
    }

    .title-2 {
      text-align: center;
      font-family: "OPPO-B";
      font-size: 22px;
      color: #000;
    }

    .textlayout{
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: center;
    }
    .separator {
      height: 1.5px;
      background-color: #000;
      margin: 20px 97px;
      width: 350px;
    }

    p{
      margin-top: 17px;
    }

    .text{
      width: 100%;
    }

    .textcontent-cn{
      text-indent: 34px;
      text-align:justify;
    }

    .textcontent-en{
      text-indent: 34px;
      text-align: justify;
    }

    .img1{
      width: 90%;
      height: auto;
      margin-left: 0px;
      margin-top: 40px;
    }
    .img2 {
      width: 90%;
      height: auto;
      margin-right: 0px;
      margin-bottom: 40px;
    }
    .img3{
      width: 90%;
      height: auto;
      margin-left: 0px;
      margin-top: 40px;
    }
    }
  }
  .footer
  {
    margin-top: 120px;
  }
}
}
</style>